import { Component } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { NavController, ToastController, LoadingController, AlertController, ViewController, Config  } from 'ionic-angular';

import { Project, Master, UserMyRadiant as User } from '../../../providers/';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { cmpFilterKaryawan } from "../../../components/presensi";
import { RepositoryMyRadiant, HelperMyRadiant} from '../../../providers/';
import { CalendarResult } from 'ion2-calendar';
import { TabsPage } from '../../dashboard';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '@providers/resources/utility';

@Component({
  selector: 'presensi-leave',
  templateUrl: 'page.html'
})
export class Leave {
  loading : any;
  data = {
    leave:[{}],
    dateMulai:"",
    dateAkhir:"",
    dateJarak:"",
    employee:"Me",
  };
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID,
    nik : this.userApi.data.NIK,
    date_start : this.today.awalYmd,
    date_end : this.today.akhirYmd,
  }
  fileTransfer: FileTransferObject = this.transfer.create();
  constructor(
    public navCtrl        : NavController,
    public userApi        : User,
    public menuCtrl       : MenuController,
    public modalCtrl      : ModalController,
    public nav            : Nav,
    public navParams      : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    public events         : Events,
    public utility        : Utility,
    public transfer       : FileTransfer
  ) {
    this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
    };
    this.data.dateJarak = this.today.awal +' s/d '+this.today.akhir;
    localStorage.setItem('presensi_karyawan_attendance','me');
    this.getLeave();
  }

  getLeave(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListLeave(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.leave = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  filterKaryawan(){
    let me = this;
    this.loading = this.helper.showLoading("Loading Data");
    let params = {
      id:this.userApi.data.Employee_ID,
    };
    this.repositoryProvider.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {karyawan:resp.data.list,isAddHoc:resp.data.isAddHoc,fiturSearching:true,title:"My Team Profile",level:resp.data.level}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          if(karyawan){
            if (karyawan=='me') {
              me.data.employee = "Me";
              me.parameter.nik = this.userApi.data.NIK;
              me.parameter.user_code = this.userApi.data.NIK;
              me.parameter.id = this.userApi.data.Employee_ID;
              me.parameter.flag = "team";
            }else{
              me.data.employee = karyawan.name;
              me.parameter.nik = karyawan.nik;
              me.parameter.user_code = karyawan.nik;
              me.parameter.id = karyawan.id;
              me.parameter.flag = "team";
            }
            // this.showLoading();
            me.getLeave();
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

  openCalendar(){
    let me = this;
    this.helper.startDate = me.startDate;
    this.helper.valDateJarak = this.valDateJarak;
    this.helper.openCalendar((data,role) => {

      if (role=="done") {
        let date = data;
        let from: CalendarResult = date.from;
        let to: CalendarResult = date.to;	
          this.startDate = from.dateObj;
          me.startDate = from.dateObj;
          this.parameter.date_start = from.string;
          this.parameter.date_end = to.string;
          this.data.dateJarak = this.helper.dateToString(from.dateObj) + ' s/d ' + this.helper.dateToString(to.dateObj);
          me.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          }
          this.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          };
          me.getLeave();
          
      }
    })
  }
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }
 
  previewAttachment(file){
    // console.log(this.api.url+file);
    this.helper.previewFoto(file);
  }
  downloadAttachment(file,name_real) {
    this.loading = this.helper.showLoading("Downloading...");
    let direktori = this.utility.getDirMyRadiant();
    this.fileTransfer.download(file, direktori + name_real,true).then((entry) => {
      try {
        this.loading.dismiss();
        this.helper.presentSwal('Success','Download Complete. Your file has saved in '+entry.toURL());
      } catch (error) {}
    }, (error) => {
      // handle error
      console.log(error);
      try {
        this.loading.dismiss();
        this.helper.presentSwal('Failed','Error Download File. Check your connection and try again.','error');
      } catch (error) {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/presensi/leave/page.ts